import { Globals } from "../../global/Globals";

export default function Halfpageheader(props){
const {headerValue,onClose,proposalData,handleBackPress,setToBeAssigned}=props;
const backPress=()=>{
  handleBackPress();
  setToBeAssigned(false)
}

const Title = props.ProposalTitle 
  ? `- ${props.ProposalTitle} `
  : proposalData?.[0]?.title || proposalData?.[0]?.projectTitle 
    ? `- ${proposalData?.[0]?.title || proposalData?.[0]?.projectTitle}` 
    : "";

return(
  <>
  {proposalData?.length?<>
<div className="Half-Page-Header-Wrapper-prop">
            <div>
              {proposalData && proposalData?.length && (
                <>
                  <p className="unsolicated-proposal-heading">
                    {proposalData?.[0]?.propRefNo}{" "}

                    {Title}
                  </p>{" "}
                </>
              )}
            </div>
            <span className="HalfPage-close-icon-prop" onClick={onClose}>
              &times;
            </span>
          </div>
  </>: props.isAssignedBrief?<div>
  <div className="Half-Page-Header-Wrapper">
                <span className="HalfPage-close-icon HalfPage-close-icon-brief" onClick={onClose}>
                  &times;
                </span>

              </div>
  </div>:<>
  <div className="Half-Page-Header-Wrapper-prop  assign-header-margin-16px"  style={{position:"fixed", zIndex:1}}>
    <div>
      {/* {proposalData && proposalData?.length && ( */}
        <div style={{display:"flex"}}>
        <img src={Globals.IMG.LEFT_ARROW} alt="close" onClick={backPress} /><p className="assign-proposal-heading">
          {headerValue}
          </p>{" "}
        </div>


{/* )} */}
    </div>
    <span className="HalfPage-close-icon-prop" onClick={onClose}>
      &times;
    </span>
  </div>
  </>}
  </>
    
)}